
import { supabase } from '@/integrations/supabase/client';
import { ProcurementAudit, CreateProcurementAuditInput } from '@/types/database.types';

export const createProcurementAudit = async (data: CreateProcurementAuditInput): Promise<ProcurementAudit> => {
  const { data: result, error } = await supabase
    .from('procurement_audit')
    .insert([data])
    .select()
    .single();

  if (error) {
    console.error('Error creating procurement audit:', error);
    throw error;
  }

  return result as ProcurementAudit;
};

export const getProcurementAuditTrail = async (procurementId: string): Promise<ProcurementAudit[]> => {
  const { data, error } = await supabase
    .from('procurement_audit')
    .select('*')
    .eq('procurement_id', procurementId)
    .order('created_at', { ascending: false });

  if (error) {
    console.error('Error fetching procurement audit trail:', error);
    throw error;
  }

  return data as ProcurementAudit[];
};

export const logStatusChange = async (
  procurementId: string,
  oldStatus: string,
  newStatus: string,
  changedBy: string,
  changeReason?: string,
  metadata?: Record<string, any>
): Promise<ProcurementAudit> => {
  const auditData: CreateProcurementAuditInput = {
    procurement_id: procurementId,
    action: 'status_change',
    old_status: oldStatus,
    new_status: newStatus,
    changed_by: changedBy,
    change_reason: changeReason,
    metadata: metadata
  };

  return createProcurementAudit(auditData);
};
